// extracted by mini-css-extract-plugin
export default {"errorContainer":"Error_errorContainer__km36G","errorType":"Error_errorType__LqUqq","errorDescription":"Error_errorDescription__KyOCp","homeLink":"Error_homeLink__NkxjA"};